export const AllocationsHeader = () => {
  return (
    <div className="flex flex-col justify-between gap-3 px-4 pt-3 md:flex-row md:items-center">
      <h1 className="text-2xl font-semibold">Allocations</h1>
    </div>
  );
};
